var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { staticClass: "header clearfix" }, [
    _c(
      "div",
      { staticClass: "main_header" },
      [
        _c(
          "div",
          {
            staticClass: "fl",
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.toHomePage($event)
              }
            }
          },
          [
            _vm.$route.query.origin == "zn"
              ? _c("div", { staticStyle: { "line-height": "50px" } }, [
                  _c("span", { staticStyle: { "font-size": "20px" } }, [
                    _vm._v(_vm._s(_vm.clientName))
                  ])
                ])
              : _c(
                  "div",
                  {
                    style:
                      _vm.bmsAppLen > 1 && !_vm.isInChoose
                        ? "cursor: pointer;"
                        : "",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.goHome($event)
                      }
                    }
                  },
                  [
                    _c("img", {
                      staticStyle: { width: "150px", "object-fit": "contain" },
                      attrs: { src: _vm.logoUrl, alt: "" }
                    })
                  ]
                )
          ]
        ),
        _vm._v(" "),
        _vm.userName && _vm.needMenu
          ? _c(
              "div",
              { staticClass: "fr" },
              [
                _c(
                  "el-menu",
                  {
                    staticClass: "el-menu-demo",
                    attrs: { mode: "horizontal" }
                  },
                  [
                    _c(
                      "el-submenu",
                      { attrs: { index: "1" } },
                      [
                        _c("template", { slot: "title" }, [
                          _c("div", { staticClass: "user-icon" }, [
                            _c("img", { attrs: { src: _vm.userIcon, alt: "" } })
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "user-name",
                              attrs: { title: _vm.userName }
                            },
                            [_vm._v(_vm._s(_vm.userName))]
                          )
                        ]),
                        _vm._v(" "),
                        _vm.hrefType.indexOf("choose") === -1 &&
                        _vm.needCompany &&
                        _vm.isWxLogin
                          ? _c(
                              "el-menu-item",
                              {
                                attrs: { index: "2-1" },
                                on: { click: _vm.toUserCenterPage }
                              },
                              [
                                _c("div", { staticClass: "zdy-menu-center" }, [
                                  _c("i", { staticClass: "icon-account" }),
                                  _vm._v("个人中心")
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.hrefType.indexOf("choose") === -1 &&
                        _vm.needCompany &&
                        _vm.isWxLogin
                          ? _c(
                              "el-menu-item",
                              {
                                attrs: { index: "2-2" },
                                on: { click: _vm.toHelpPage }
                              },
                              [
                                _c("div", { staticClass: "zdy-menu-center" }, [
                                  _c("i", { staticClass: "icon-help-center" }),
                                  _vm._v("帮助中心")
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "el-menu-item",
                          {
                            attrs: { index: "2-3" },
                            on: { click: _vm.logout }
                          },
                          [
                            _c("div", { staticClass: "zdy-menu-center" }, [
                              _c("i", { staticClass: "icon-sign-out" }),
                              _vm._v("退出登录")
                            ])
                          ]
                        )
                      ],
                      2
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.needCompany
          ? _c("company", { staticClass: "company-box" })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }